var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTapbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2662 2.55469H10.3579C9.05433 2.55469 7.9751 3.62785 7.9751 4.93748V17.9368C7.9751 19.2464 9.04826 20.3195 10.3579 20.3195H23.2662C24.5758 20.3195 25.649 19.2464 25.649 17.9368V4.93748C25.649 3.62785 24.5758 2.55469 23.2662 2.55469ZM34.762 20.18H26.3949C25.5522 20.18 24.8488 20.8772 24.8488 21.72V30.1416C24.8488 31.3603 24.5275 31.7787 23.3088 31.7787H15.6451C14.8993 31.7787 14.2445 32.385 14.2445 33.1792V40.8854C14.2445 41.6312 14.8508 42.286 15.6451 42.286H23.3088C24.0546 42.286 24.7094 41.6797 24.7094 40.8854V33.1732C24.7094 31.6731 25.3714 31.6741 26.3079 31.6755C26.3367 31.6755 26.3657 31.6756 26.3949 31.6756H34.762C35.5987 31.6756 36.302 30.9783 36.302 30.1356V21.72C36.302 20.8833 35.6048 20.18 34.762 20.18Z",
    fill: "#3576EE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapbit);
export default __webpack_public_path__ + "static/media/tapbit.ec8db2de7be10058336acfee68004377.svg";
export { ForwardRef as ReactComponent };